<template>
  <v-btn
    v-if="!imperial"
    outlined
    class="bordered-button"
    small
    :loading="loading"
    :ripple="false"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <div class="d-flex">
      <v-icon size="16" class="me-1" color="blue-grey darken-1"
        >mdi-swap-horizontal</v-icon
      >
      <p class="ma-0 pa-0 blue-grey--text text--darken-1 caption">
        {{ $t('insights.imperial_system') }}
      </p>
    </div>
  </v-btn>
  <v-btn
    v-else
    small
    class="active-bordered-button"
    :loading="loading"
    :ripple="false"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <div class="d-flex">
      <v-icon size="16" class="me-1" color="blue-grey darken-1"
        >mdi-swap-horizontal</v-icon
      >
      <p class="ma-0 pa-0 blue-grey--text text--darken-1 caption">
        {{ $t('insights.imperial_system') }}
      </p>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'ImperialSystemButton',

  props: {
    loading: Boolean,
    disabled: Boolean,
    imperial: Boolean,
  },
}
</script>

<style lang="scss">
.insight-card {
  .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: inherit !important;
    .v-btn__loader {
      .v-progress-circular {
        height: 16px !important;
        width: 16px !important;
        color: $color-blue-grey-darken1 !important;
      }
    }
  }

  .v-btn__loader {
    .v-progress-circular {
      height: 16px !important;
      width: 16px !important;
      color: $color-blue-grey-darken1 !important;
    }
  }

  .v-btn.v-size--small {
    padding: 4px 8px;
  }

  .v-btn__content {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .bordered-button {
    border-radius: 4px !important;
    border: 1px solid $color-blue-grey-lighten2 !important;
    &:hover {
      background-color: $color-blue-grey-lighten3 !important;
    }
  }

  .active-bordered-button {
    border-radius: 4px !important;
    border: 1px solid $color-blue-grey-lighten2 !important;
    background-color: $color-blue-grey-lighten3 !important;
    &:hover {
      background-color: $color-blue-grey-lighten3 !important;
    }
  }

  .bordered-button.v-btn::before {
    background-color: $color-blue-grey-lighten3 !important;
  }

  .active-bordered-button.v-btn::before {
    background-color: $color-blue-grey-lighten3 !important;
  }
}
</style>
